import { HotelFilter } from './hotelFilters';

export const enum HotelSelectionFilterEventGroup {
  HotelName = 'hotelName',
  Rules = 'rules',
  TypeOfAccommodation = 'typeOfAccommodation',
  Rating = 'rating',
  Meals = 'meals',
  Amenities = 'amenities',
  Experience = 'experience',
  NeighborhoodPolygons = 'neighborhoodPolygons',
  Popular = 'popular',
  Price = 'price',
  PreviouslySeen = 'previously_seen',
}

export const enum HotelSelectionFilterEventName {
  HotelName = 'hotelName',
  FreeCancellation = 'freeCancellation',
  Hotel = 'hotel',
  Apartment = 'apartment',
  HouseOrCottage = 'houseOrCottage',
  Stars = 'stars',
  FourPlusStars = '4+',
  NoMeals = 'noMeals',
  Breakfast = 'breakfast',
  HalfBoard = 'halfBoard',
  FullBoard = 'fullBoard',
  AllInclusive = 'allInclusive',
  Pool = 'pool',
  Parking = 'parking',
  Spa = 'spa',
  Gym = 'gym',
  Wifi = 'wifi',
  AirConditioned = 'airConditioned',
  VehicleChargingStation = 'vehicleChargingStation',
  Business = 'business',
  Family = 'family',
  PetsAllowed = 'petsAllowed',
  GreenSustainableProperty = 'greenSustainableProperty',
  NeighborhoodPolygons = 'neighborhoodPolygons',
  MaxPricePerNight = 'maxPricePerNight',
  MinimumGuestRating = 'minimumGuestRating',
  PreviouslySeen = 'previouslySeen',
}

export interface HotelSelectionFilterEventIdentifier {
  filterGroup: HotelSelectionFilterEventGroup;
  filterName: HotelSelectionFilterEventName;
}

export const HOTEL_FILTER_EVENT_IDENTIFIERS: Record<
  HotelFilter,
  HotelSelectionFilterEventIdentifier
> = {
  [HotelFilter.HotelName]: {
    filterGroup: HotelSelectionFilterEventGroup.HotelName,
    filterName: HotelSelectionFilterEventName.HotelName,
  },
  [HotelFilter.RuleFreeCancellation]: {
    filterGroup: HotelSelectionFilterEventGroup.Rules,
    filterName: HotelSelectionFilterEventName.FreeCancellation,
  },
  [HotelFilter.AccommodationTypeHotel]: {
    filterGroup: HotelSelectionFilterEventGroup.TypeOfAccommodation,
    filterName: HotelSelectionFilterEventName.Hotel,
  },
  [HotelFilter.AccommodationTypeApartment]: {
    filterGroup: HotelSelectionFilterEventGroup.TypeOfAccommodation,
    filterName: HotelSelectionFilterEventName.Apartment,
  },
  [HotelFilter.AccommodationTypeHouseOrCottage]: {
    filterGroup: HotelSelectionFilterEventGroup.TypeOfAccommodation,
    filterName: HotelSelectionFilterEventName.HouseOrCottage,
  },
  [HotelFilter.RatingStars]: {
    filterGroup: HotelSelectionFilterEventGroup.Rating,
    filterName: HotelSelectionFilterEventName.Stars,
  },
  [HotelFilter.MealsNoMeals]: {
    filterGroup: HotelSelectionFilterEventGroup.Meals,
    filterName: HotelSelectionFilterEventName.NoMeals,
  },
  [HotelFilter.MealsBreakfast]: {
    filterGroup: HotelSelectionFilterEventGroup.Meals,
    filterName: HotelSelectionFilterEventName.Breakfast,
  },
  [HotelFilter.MealsHalfBoard]: {
    filterGroup: HotelSelectionFilterEventGroup.Meals,
    filterName: HotelSelectionFilterEventName.HalfBoard,
  },
  [HotelFilter.MealsFullBoard]: {
    filterGroup: HotelSelectionFilterEventGroup.Meals,
    filterName: HotelSelectionFilterEventName.FullBoard,
  },
  [HotelFilter.MealsAllInclusive]: {
    filterGroup: HotelSelectionFilterEventGroup.Meals,
    filterName: HotelSelectionFilterEventName.AllInclusive,
  },
  [HotelFilter.AmenitiesPool]: {
    filterGroup: HotelSelectionFilterEventGroup.Amenities,
    filterName: HotelSelectionFilterEventName.Pool,
  },
  [HotelFilter.AmenitiesParking]: {
    filterGroup: HotelSelectionFilterEventGroup.Amenities,
    filterName: HotelSelectionFilterEventName.Parking,
  },
  [HotelFilter.AmenitiesSpa]: {
    filterGroup: HotelSelectionFilterEventGroup.Amenities,
    filterName: HotelSelectionFilterEventName.Spa,
  },
  [HotelFilter.AmenitiesGym]: {
    filterGroup: HotelSelectionFilterEventGroup.Amenities,
    filterName: HotelSelectionFilterEventName.Gym,
  },
  [HotelFilter.AmenitiesWifi]: {
    filterGroup: HotelSelectionFilterEventGroup.Amenities,
    filterName: HotelSelectionFilterEventName.Wifi,
  },
  [HotelFilter.AmenitiesAirConditioned]: {
    filterGroup: HotelSelectionFilterEventGroup.Amenities,
    filterName: HotelSelectionFilterEventName.AirConditioned,
  },
  [HotelFilter.AmenitiesVehicleChargingStation]: {
    filterGroup: HotelSelectionFilterEventGroup.Amenities,
    filterName: HotelSelectionFilterEventName.VehicleChargingStation,
  },
  [HotelFilter.ExperienceBusiness]: {
    filterGroup: HotelSelectionFilterEventGroup.Experience,
    filterName: HotelSelectionFilterEventName.Business,
  },
  [HotelFilter.ExperienceFamily]: {
    filterGroup: HotelSelectionFilterEventGroup.Experience,
    filterName: HotelSelectionFilterEventName.Family,
  },
  [HotelFilter.ExperiencePetsAllowed]: {
    filterGroup: HotelSelectionFilterEventGroup.Experience,
    filterName: HotelSelectionFilterEventName.PetsAllowed,
  },
  [HotelFilter.ExperienceGreenSustainableProperty]: {
    filterGroup: HotelSelectionFilterEventGroup.Experience,
    filterName: HotelSelectionFilterEventName.GreenSustainableProperty,
  },
  [HotelFilter.NeighborhoodPolygons]: {
    filterGroup: HotelSelectionFilterEventGroup.NeighborhoodPolygons,
    filterName: HotelSelectionFilterEventName.NeighborhoodPolygons,
  },
};

export const HOTEL_SELECTION_CLIENT_FILTER_EVENT_IDENTIFIERS = {
  maxPricePerNight: {
    filterGroup: HotelSelectionFilterEventGroup.Price,
    filterName: HotelSelectionFilterEventName.MaxPricePerNight,
  },
  minimumGuestRating: {
    filterGroup: HotelSelectionFilterEventGroup.Rating,
    filterName: HotelSelectionFilterEventName.MinimumGuestRating,
  },
  previouslySeen: {
    filterGroup: HotelSelectionFilterEventGroup.PreviouslySeen,
    filterName: HotelSelectionFilterEventName.PreviouslySeen,
  },
} as const satisfies Record<
  'maxPricePerNight' | 'minimumGuestRating' | 'previouslySeen',
  HotelSelectionFilterEventIdentifier
>;
